/**
 * note: not sure if should change file name to be filename.helper.ts or not
 */

/**
 * getUploadedFilename
 * - rename file if nescessary
 * - add -<number> if the filename is already exists
 * - say origninal has long.pdf and long-1.pdf
 * - the result should be long-2.pdf
 * - keep searchhing if found, add +1 then call again, if don't find return that filename
 */

const getNameAndExt = (fullFilename: string) => {
  const suffixR = /.\w+$/;
  const stripedSuffix = fullFilename.replace(suffixR, '');
  if (!stripedSuffix || stripedSuffix.length >= fullFilename.length)
    throw Error('no suffix');
  const matchedList = fullFilename?.match(suffixR);
  if (!matchedList || !matchedList.length)
    throw Error('cannot find ext');
  return {
    name: stripedSuffix,
    ext: matchedList[0],
  };
};

// TODO: should compile full list on top of the page
const replaceExtPdfNameWithExt = (name) => {
  const regEx = /_(gif|jpg|jpeg|tif|tiff|png|rtf|html|doc|docx|txt)\.pdf$/;
  const m = name.match(regEx);
  return m ? name.replace(regEx, `.${m[1]}`) : name;
};

const getUploadedFilename = (
  filename: string | undefined,
  attachmentsNames: Array<string>,
  skipConvertOld = false,
) => {
  // console.log("attachmentsNames", attachmentsNames, "filename", filename);
  // convert _png.pdf back to .png
  const newAttsNames = attachmentsNames.map((name) =>
    skipConvertOld ? name : replaceExtPdfNameWithExt(name),
  );

  if (!filename) throw Error('filename should not be empty');

  console.debug(
    `getUploadedFilename newAttsNames`,
    newAttsNames,
    filename,
  );
  if (!newAttsNames.includes(filename)) {
    // not found exact match
    return filename;
  }

  const { name: stripedSuffix, ext: suffix } = getNameAndExt(
    filename,
  );

  const dashNum = /(\w+)-(\d+)$/;
  const resultFromMatch = stripedSuffix.match(dashNum);
  // if (!resultFromMatch || !resultFromMatch.length)
  //   throw Error(
  //     `couldn't find the match ${JSON.stringify({
  //       resultFromMatch,
  //       stripedSuffix,
  //       suffix,
  //     })}`,
  //   );
  const matchedNum = resultFromMatch && resultFromMatch[2];
  let newFileName = '';
  if (matchedNum) {
    const intNum = parseInt(matchedNum);
    if (!isNaN(intNum)) {
      newFileName = `${resultFromMatch && resultFromMatch[1]}-${
        intNum + 1
      }${suffix}`;
    }
  } else {
    newFileName = `${stripedSuffix}-${1}${suffix}`;
  }
  return getUploadedFilename(newFileName, attachmentsNames);
};

export const FilenameHelper = { getUploadedFilename };
